import React, { useState } from "react";
import { Dropdown, Button } from "antd";
import {
  HolderOutlined,
  DeleteOutlined,
  LayoutOutlined,
} from "@ant-design/icons";

import "../../styles/bulletinAdmin/components/blockMenu.scss";

export default function EbulletinActionMenu({
  block,
  index,

  handleTwoColumn,
  handleDeleteBlock,
}) {
  const [open, setOpen] = useState(false);

  // Define the menu items with key, icon, and title, just like the insert menu
  const actionItems = [
    { type: "divider" },
    // {
    //   key: "two-column",
    //   icon: <LayoutOutlined />,
    //   title: "2 Column Layout",
    //   onClick: handleTwoColumn,
    //   disabled: block.layout === "two-column",
    // },
    { type: "divider" },
    {
      key: "delete",
      icon: <DeleteOutlined />,
      title: "Delete Block",
      danger: true,
      onClick: () => handleDeleteBlock(index),
    },
  ];

  const handleItemClick = (item) => {
    if (!item.disabled && item.onClick) {
      item.onClick();
    }
    setOpen(false); // Close the dropdown after any click
  };

  // Render a custom div that mimics the structure of the insert menu
  const actionMenuContent = (
    <div className="block-insert-menu action-menu">
      <div className="block-list">
        {actionItems.map((item, idx) => {
          if (item.type === "divider") {
            return <div key={`divider-${idx}`} className="menu-divider" />;
          }
          return (
            <div
              key={item.key}
              className={`block-item ${item.disabled ? "disabled" : ""} ${
                item.danger ? "danger" : ""
              }`}
              onClick={() => handleItemClick(item)}
            >
              <div className="block-icon media">{item.icon}</div>
              <div className="block-content">
                <div className="block-title">{item.title}</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );

  return (
    <Dropdown
      overlay={actionMenuContent}
      trigger={["click"]}
      placement="bottomLeft"
      open={open}
      onOpenChange={setOpen}
    >
      <Button icon={<HolderOutlined />} size="small" type="text" />
    </Dropdown>
  );
}
